export default __webpack_public_path__ + "static/media/two_center.e0e23244.png";